import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { Sort } from '../sorts/sort';

@Directive({
  selector: '[appSort]'
})
export class SortDirective {

  @Input() appSort: Array<any>;

  constructor(private renderer: Renderer2, private targetElem: ElementRef) { }

  @HostListener("click")
  sortData() {
    //Cria objeto da classe Sort
    const sort = new Sort();
    // Pega referência do atual Elemento clicado
    const elem = this.targetElem.nativeElement;
    // Pega em qual Ordenação deverá ser aplicado, por padrâo deverá ser desc
    const order = elem.getAttribute("data-order");
    // Pega o tipo de propriedade e aplica [data-type=date] se for um campo data
    const type = elem.getAttribute("data-type");
    // Pega o nome da propriedade pelo Element Attribute
    const property = elem.getAttribute("data-name");

    if (order === "desc") {
      this.appSort.sort(sort.startSort(property, order, type));
      elem.setAttribute("data-order", "asc");
    } else {
      this.appSort.sort(sort.startSort(property, order, type));
      elem.setAttribute("data-order", "desc");
    }
  }
}
